import {
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';
import { PlayerLicenseService } from '../../services/player-license.service';

@Component({
  selector: 'interactive-license-counts',
  template: ` <span>{{ licensesLeft() }} / {{ licensesTotal() }}</span> `,
  standalone: false,
})
export class InteractiveLicenseCountsComponent implements OnInit, OnDestroy {
  private subscription: Subscription | null = null;
  private playerLicenseService = inject(PlayerLicenseService);
  private broadcasterService = inject(BroadcasterService);

  countOnly = input<boolean>(false);
  licensesLeft = signal<number>(
    this.playerLicenseService.getInteractiveAvailableLicenseCount(),
  );
  licensesTotal = signal<number>(
    this.playerLicenseService.getInteractiveLicenseCount(),
  );

  ngOnInit(): void {
    this.subscription = this.broadcasterService.on(
      'risevision.company.updated',
      () => {
        this.licensesLeft.set(
          this.playerLicenseService.getInteractiveAvailableLicenseCount(),
        );
        this.licensesTotal.set(
          this.playerLicenseService.getInteractiveLicenseCount(),
        );
      },
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
